// Product Upsell Widget JavaScript
// File: assets/product-upsell-widget.js

class ProductUpsellWidget {
  constructor(container) {
    this.container = container;
    this.checkbox = container.querySelector('[data-upsell-toggle]');
    this.content = container.querySelector('[data-upsell-content]');
    this.variantSelector = container.querySelector('[data-upsell-variant-id]');
    this.quantityInput = container.querySelector('[data-upsell-quantity]');
    this.redirectToCart = container.dataset.redirectToCart === 'true';
    
    this.init();
  }

  init() {
    if (!this.checkbox) return;
    
    // Toggle content visibility
    this.checkbox.addEventListener('change', (e) => this.toggleContent(e));
    
    // Intercept form submission
    this.interceptCartSubmit();
  }

  toggleContent(e) {
    if (e.target.checked) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.content.style.opacity = '1';
    } else {
      this.content.style.maxHeight = '0';
      this.content.style.opacity = '0';
    }
  }

  interceptCartSubmit() {
    const mainForm = this.container.closest('product-form')?.querySelector('form') || 
                     this.container.closest('form') || 
                     document.querySelector('form[action*="/cart/add"]');
    
    if (!mainForm) return;

    mainForm.addEventListener('submit', async (e) => {
      if (!this.checkbox.checked) return; // Let normal submission happen

      e.preventDefault();
      e.stopPropagation();

      await this.addBothProducts(mainForm);
    });
  }

  async addBothProducts(mainForm) {
    const mainFormData = new FormData(mainForm);
    const mainVariantId = mainFormData.get('id');
    const mainQuantity = mainFormData.get('quantity') || 1;

    const upsellVariantId = this.variantSelector?.value;
    const upsellQuantity = this.quantityInput?.value || 1;

    if (!upsellVariantId) {
      this.showError('Please select a variant for the add-on product');
      return;
    }

    // Show loading state
    const submitBtn = mainForm.querySelector('[type="submit"]');
    const originalBtnText = submitBtn?.textContent;
    if (submitBtn) submitBtn.textContent = 'Adding...';

    try {
      const items = [
        { id: mainVariantId, quantity: parseInt(mainQuantity) },
        { id: upsellVariantId, quantity: parseInt(upsellQuantity) }
      ];

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (response.ok) {
        // Trigger theme's cart refresh
        this.refreshCart();
        
        // Redirect or open cart drawer based on settings
        if (this.redirectToCart) {
          window.location.href = '/cart';
        }
      } else {
        const error = await response.json();
        this.showError(error.message || 'Error adding products to cart');
      }
    } catch (error) {
      console.error('Cart error:', error);
      this.showError('Error adding products to cart. Please try again.');
    } finally {
      if (submitBtn) submitBtn.textContent = originalBtnText;
    }
  }

  refreshCart() {
    // Trigger various cart refresh methods used by different themes
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    
    // Horizon theme specific
    if (window.theme?.cart?.refresh) {
      window.theme.cart.refresh();
    }
    
    // Try to open cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
    
    // Alternative cart drawer selectors
    const cartDrawerAlt = document.querySelector('[data-cart-drawer]');
    if (cartDrawerAlt) {
      cartDrawerAlt.classList.add('is-open');
    }
  }

  showError(message) {
    alert(message);
  }
}

// Initialize all upsell widgets on page
document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('[data-upsell-widget]');
  widgets.forEach(widget => new ProductUpsellWidget(widget));
});

// Also initialize after dynamic content loads (for quick view, etc)
if (window.Shopify && Shopify.theme) {
  document.addEventListener('shopify:section:load', () => {
    const widgets = document.querySelectorAll('[data-upsell-widget]');
    widgets.forEach(widget => new ProductUpsellWidget(widget));
  });
}